var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.li_classes},[_c('a',{class:_vm.a_classes,attrs:{"href":"javascript: void(0);"},on:{"click":_vm.sendClick}},[_vm._t("default",[_vm._v(_vm._s(_vm.value))])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }